import React from 'react';
import './Hero.css'; // Import the CSS for styling

const Hero = (props) => {
  return (
    <section className="hero" id='home'>
      <div className="hero-content">
        <h1 className="hero-headline">Building Simple Solutions for Complex Problems</h1>
        <p className="hero-subtext">
          We make intuitive apps and websites that empower users with efficiency and clarity. We also provide custom solutions for businesses and creators.
        </p>
        <div className="hero-cta">
          <button className="cta-primary" onClick={() => props.isForm(true)}>Get Started</button>
          {/* <button className="cta-secondary">Learn More</button> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
